import { render, staticRenderFns } from "./MediaSubtitleBlock.vue?vue&type=template&id=562ffce4"
import script from "./MediaSubtitleBlock.vue?vue&type=script&lang=js"
export * from "./MediaSubtitleBlock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports